import { css } from "../../../../styled-system/css";

interface Props {
  percent: number;
  height?: number;
  trackColor?: string;
}

const DEFAULT_TRACK = "#efefef"; // = `expanderBackground` token

export const PhaseProgressBar = ({ percent, height = 7, trackColor = DEFAULT_TRACK }: Props) => {
  const width = `${Math.min(100, Math.max(0, percent))}%`;

  return (
    <div
      style={{ backgroundColor: trackColor }}
      className={css({
        height: `${height}px`,
        borderRadius: "pill",
        border: "1px solid {colors.border.default}",
        overflow: "hidden",
      })}
    >
      <div
        style={{ width }}
        className={css({
          height: "100%",
          borderRadius: "pill",
          backgroundColor: "royalPurple",
          transition: "width 0.4s ease",
        })}
      />
    </div>
  );
};
